import type { ListCharterPromotionPricingInventoryParams } from '~/types/charterPromotionPricingInventory';

export const charterPromotionQueryKeys = {
  all: ['flights-charter', 'promotions'] as const,
  lists: () => [...charterPromotionQueryKeys.all, 'list'] as const,
  list: (filters?: ListCharterPromotionPricingInventoryParams) =>
    [...charterPromotionQueryKeys.lists(), filters] as const,
};
